import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { OETrans } from 'components/translation/OETrans';
import { downloadFromLink } from 'lib/api';
import OeApiResponseRenderer from '@components/OeApiResponseRenderer';
import { translate } from 'components/translation/translation';

const DownloadFromLink = () => {
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const fileId = params.get('file');
	const expires = params.get('expires');
	const signature = params.get('signature');
	const [sbShow, setSbShow] = useState(<></>);
	const [isError, setIsError] = useState(false);
	//console.log('file', fileId);

	const handleStatusBar = (dataToHandle) => {
		setSbShow(<OeApiResponseRenderer dataToHandle={dataToHandle} />);
	};

	useEffect(() => {
		if (fileId && expires && signature) {
			setSbShow(<></>);
			setIsError(false);

			downloadFromLink(`download?file=${fileId}&expires=${expires}&signature=${signature}`).then((resp) => {
				//console.log('resp', resp);

				if (!resp.ok) {
					if (resp.status === 403) {
						setIsError(true);

						handleStatusBar({
							success: false,
							message: 'Url non valido o scaduto',
						});
					} else if (resp.status !== 200) {
						setIsError(true);

						handleStatusBar({
							success: false,
							message: translate('common.error.save', "Si è verificato un errore durante l'elaborazione delle informazioni"),
						});
					}
				} else {
               handleStatusBar({
                  success: true,
                  message: 'Il download del file che hai richiesto è stato avviato',
               });
            }
			});
		} else {
			setIsError(true);
		}
	}, [expires, fileId, signature]);

	return (
		<div className="simple-box text-center not-found error">
			<Row>
				<Col className="mt-3">
					<div className={isError ? 'mb-5 mt-3' : ''}>{sbShow}</div>

					<Link to="/projects">
						<OETrans code="common.404.link" fallback={'Ritorna ai progetti'} />
					</Link>
				</Col>
			</Row>
		</div>
	);
};

export default DownloadFromLink;
